import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Card, colors, Flex, Text, Spacer, Icon } from '@badi/badi-components';

import { translate } from 'base/shared/Localization';
import { openBookingGuaranteeModal } from 'components/booking-guarantee-modal';
import { SEEKER_USER_ROLE } from 'datamodel/User/constants';

import { IconWrap } from './styled-components';

const ClickableCTA = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;

  &:hover {
    p {
      text-decoration: underline;
    }
  }
`;

const BadiGuaranteeCard = ({
  userRole = SEEKER_USER_ROLE,
  title = translate('booking_flow_guarantee_title'),
  cta = translate('booking_flow_guarantee_CTA'),
}) => {
  const handleGuaranteePopup = useCallback(
    (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      openBookingGuaranteeModal({ userRole });
    },
    [userRole]
  );

  return (
    <Card backgroundColor={colors.irisBlue}>
      <Spacer bottom={2} left={3} right={3} top={2}>
        <Flex alignItems="center" gutter={2}>
          <IconWrap>
            <Icon height={40} name="secure" width={38} />
          </IconWrap>
          <Flex direction="column">
            <Text body={2} bold color={colors.white} data-qa="badi-guarantee-title">
              {title}
            </Text>
            <ClickableCTA onClick={handleGuaranteePopup}>
              <Text body={3} color={colors.white} data-qa="badi-guarantee-link">
                {cta}
              </Text>
            </ClickableCTA>
          </Flex>
        </Flex>
      </Spacer>
    </Card>
  );
};

export default BadiGuaranteeCard;
